import { getAccessToken } from "@/utils/auth/getAuthUserData.ts";
import { PromotionalMessage } from "@/types/prodcatBaseTypes";

export type basketItemWithPromotions = {
  productId: string;
  quantity: number;
  price: number;
  detailedPromotionalMessages: PromotionalMessage[];
};

export type getBasketItemsReponse = {
  error: boolean;
  data: basketItemWithPromotions[];
};

export const getBasketData = async (
  basketBaseUrl: string,
): Promise<getBasketItemsReponse> => {
  return getAccessToken().then((accessToken) => {
    return fetch(basketBaseUrl, {
      method: "GET",
      credentials: "include",
      headers: {
        "x-api-client-id": "web_pdp_scaffold_promotions_ui",
        "Content-Type": "application/json",
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    }).then(
      (response: Response) => {
        if (response.ok) {
          return response.json().then((basketData) => {
            return {
              error: false,
              data: basketData.basket.commerceItems.map((commerceItem: any) => {
                return {
                  productId: commerceItem.productId || "",
                  quantity: commerceItem.quantity || 0,
                  price: commerceItem.price || 0,
                  detailedPromotionalMessages:
                    commerceItem.detailedPromotionalMessages || [],
                };
              }),
            };
          });
        }
        return {
          error: true,
          data: [],
        };
      },
      () => {
        return {
          error: true,
          data: [],
        };
      },
    );
  });
};
